/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientUserViewModelPrimeDatatableResults } from '../../models/client-user-view-model-prime-datatable-results';
import { PrimeDatatableParams } from '../../models/prime-datatable-params';

export interface GetClientUsersDataTable$Params {
  clientID: number;
      body?: PrimeDatatableParams
}

export function GetClientUsersDataTable(http: HttpClient, rootUrl: string, params: GetClientUsersDataTable$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientUserViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, GetClientUsersDataTable.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientUserViewModelPrimeDatatableResults>;
    })
  );
}

GetClientUsersDataTable.PATH = '/api/Clients/GetClientUsersDataTable/{clientID}';
